import React from 'react'
import PropTypes from 'prop-types'
import {MdMoreHoriz, MdClose} from 'react-icons/lib/md/'

export default class MySignaturesMini extends React.Component {
  static propTypes = {
    signature: PropTypes.object,
    setDefault: PropTypes.func,
    textLoading: PropTypes.string,
    deleteSignature: PropTypes.func
  }
  state = {
    openMoreOptions: false
  }

  render() {
    return (
      <div
        className="aSignature"
        onClick={() => { if (this.props.textLoading === 'n') { this.props.setDefault(this.props.signature._id) } }}
        style={{backgroundImage: `url(${this.props.signature.image.url})`}}
      >
        <div className="openMore" onClick={(e) => { e.stopPropagation(); this.setState({openMoreOptions: !this.state.openMoreOptions}) }}>
          {this.state.openMoreOptions && <MdClose size={20} />}
          {!this.state.openMoreOptions && <MdMoreHoriz size={20} />}
        </div>
        {this.state.openMoreOptions && (
          <div className="moreOptions">
            <div className="options">
              <div className="btn danger" onClick={(e) => { e.stopPropagation(); this.props.deleteSignature(this.props.signature._id) }}>Eliminar</div>
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Signature/MySignaturesMini/ASignature/index.js